export default __webpack_public_path__ + "static/media/Thumb_Glasses_01.44bf1f98.png";